import { SystemLocationsCourts } from '@/entities/SystemLocationsCourts';
import { SystemCourtsDto } from '@/infrastructure/network/dto/SystemLocationCourtsDto';

export const systemLocationCourtsDtoToSystemLocationCourts = (data: SystemCourtsDto[]): SystemLocationsCourts[] => {
	return data.map((item: SystemCourtsDto) => ({
		uuid: item.uuid,
		title: item.title
	}));
};
